export enum ABTestName {
  MonthlyPlansExperiment = "formations_pp_monthly_plans_nov2025",
  BusinessLaunchExperiment = "formations_pp_business_launch_feb2026",
  CashbackExperiment = "formations_cashback_mar_2026",
  JustRegisterExperiment = "formations_just_register_apr2026",
  ChargeWhenNoAccountExperiment = "formation_charge_when_no_account_sep2026",
}

export enum ABTestVariant {
  Control = "control",
  Treatment = "treatment",
  Treatment1 = "treatment1",
  Treatment2 = "treatment2",
}
